import styled from '@emotion/styled';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import WrongIcon from './ic-wrong.svg';

const Container = styled.div`
  position: relative;
  padding: 10px 38px 10px 30px;
  background-color: #0C151B;
  color: white;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  text-align: center;
`;

const CloseButtonDiv = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  display: flex;
  width: 24px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform: translateY(-50%);
`;

const COOKIE_NAME = 'notice-banner-closed';
const UNTIL_DATETIME = '2025-08-12T01:00:00';

const createCookie = () => {
  const date = new Date(UNTIL_DATETIME);
  document.cookie = `${COOKIE_NAME}=1; expires=${date.toUTCString()}; path=/`;
};

const hasCookie = () => {
  return document.cookie.split(';').some((item) => item.trim().startsWith(COOKIE_NAME));
};

const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <CloseButtonDiv
      onClick={onClose}
    >
      <Image
        src={WrongIcon}
        style={{ width: '16px' }}
        alt="닫기"
      />
    </CloseButtonDiv>
  );
};

const NoticeBanner = () => {
  const [showNotice, setShowNotice] = useState<boolean>(false);

  useEffect(() => {
    setShowNotice(!hasCookie() && new Date().getTime() < new Date(UNTIL_DATETIME).getTime());
  }, []);

  const onClose = () => {
    createCookie();
    setShowNotice(false);
  };

  return (
    showNotice ? (
      <Container>
        <span>서비스 안정화를 위해서 <strong>2025년 8월 12일 00시부터 03시까지 </strong>서비스 점검이 예정되어 있습니다. 점검 시간에는 서비스 이용이 중단될 예정이니 양해해 주시기 바랍니다. 감사합니다.</span>
        <CloseButton onClose={onClose} />
      </Container>
    ) : null
  );
};

export default NoticeBanner;
